import { useCallback, useState } from "react";
function useStorting(sorting, texts) {
  const [sortingState, setSortingState] = useState(sorting);
  const toggleSorting = useCallback(() => {
    setSortingState((prev) => {
      if (prev === "disabled") return "disabled";
      return prev === "on" ? "off" : "on";
    });
  }, []);
  const showSortingToggle = sorting !== "disabled";
  const toggleSortingLabel = sortingState === "on" ? texts.disableSorting : texts.enableSorting;
  return {
    sortingState,
    toggleSorting,
    showSortingToggle,
    toggleSortingLabel
  };
}
export {
  useStorting
};
//# sourceMappingURL=useStorting.js.map
